import { RequestBase } from './request-base';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class APIKeyService extends RequestBase {
    BasePath = 'api/settings/apikeys';

    // #region APIKey
    GetApiKeys(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/getapikeys', this.options);
    }

    GetApiKey(sid): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/getapikey?sid=' + sid, this.options);
    }

    CreateNewApiKey(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/createnewapikey', this.options);
    }

    SaveApiKey(dtp): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + '/saveapikey', dtp, this.options);
    }

    DeleteApiKey(sid): Observable<any> {
        return this.http.delete<any>(this.API_BASE_URL + this.BasePath + '/deleteapikey?sid=' + sid, this.options);
    }
    // #endregion
}
